import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import TextField from '@mui/material/TextField';
import MDButton from "components/MDButton";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
//import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import FormField from "layouts/pages/account/components/FormField";
import MDEditor from "components/MDEditor";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MapSelect from './map';
import MDSnackbar from "components/MDSnackbar";
import config from "../../../../config";
// Import cluster data (array of { id: number, name: string })
import clustersData from '../../../map/data/response/cluster_response.json';
/**
 * VIEW-ONLY Intervention Form
 * - Fetches by id from route
 * - Prefills fields same as edit
 * - All controls disabled
 * - Shows coordinates and existing file info
 *
 * Optional prop:
 *  - onPositionLoaded([lng, lat]) -> to let parent map update
 */
const InterventionFormReadOnly = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [loadingPrefill, setLoadingPrefill] = useState(false);
    const [existingFile, setExistingFile] = useState(null);   // server file object
const [pdfFile, setPdfFile] = useState(null);             // new local File
const [uploadingFile, setUploadingFile] = useState(true);
const [deletingFile, setDeletingFile] = useState(true);

const pdfInputRef = useRef(null);

  const [island, setIsland] = useState('');
  const [programmed, setProgrammed] = useState('');
  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [code, setCode] = useState('');
  const [timerange, setTimeRange] = useState({ from: '', to: '' });
  const [cluster, setCluster] = useState(''); // stores cluster id
  const [position, setPosition] = useState(null);//[0,0]
  const [fileName, setFileName] = useState(''); // file name
  const [status, setStatus] = useState(''); // Κατάσταση παρέμβασης
  const [description, setDescription] = useState(''); // Σύντομη Περιγραφή/Παρατηρήσεις
  const fileInputRef = useRef(null);


  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);



  const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
  const API_URL = config.MAP_MATCHING_API_URL;

  const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), sizes.length - 1);
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
};


useEffect(() => {
  const fetchIntervention = async () => {
    if (!id) return;

    setLoadingPrefill(true);
    try {
      // Assumption: GET endpoint exists at /interventions/{id}
      // If your backend uses a different GET route, paste the curl and I’ll adjust.
      const res = await axios.get(`${API_URL}/interventions/${id}`, {
        headers: {
          "X-API-Key": API_TOKEN,
          "Content-Type": "application/json",
        },
      });

      const data = res.data;
      console.log("Fetched intervention for prefill:", data);
      console.log("Fetched intervention geometry:", JSON.stringify(data));

      // ---- Map API -> form state ----
      setIsland(data?.islandId ?? "");
      setCategory(data?.categoryId ?? "");
      setSubCategory(data?.subcategoryId ?? "");
      setStatus(data?.statusId ?? "");
      setCluster(data?.clusterId ?? "");
      setExistingFile(data?.file ?? null);
     setPdfFile(null);

      // Make subcategory dropdown appear by setting selectedCategory object
      const catObj = categorySub.find((c) => c.id === (data?.categoryId ?? ""));
      setSelectedCategory(catObj || null);

      setDescription(data?.description ?? "");

const raw = data?.geometry?.coordinates;

// supports:
// 1) [[lat, lon]]
// 2) [lon, lat] (if it ever comes this way)
let lat;
let lon;

if (Array.isArray(raw) && raw.length > 0 && Array.isArray(raw[0]) && raw[0].length === 2) {
  // [[lat, lon]]
  lat = raw[0][0];
  lon = raw[0][1];
} else if (Array.isArray(raw) && raw.length === 2 && typeof raw[0] === "number" && typeof raw[1] === "number") {
  // [lon, lat]
  lon = raw[0];
  lat = raw[1];
}

if (typeof lat === "number" && typeof lon === "number") {
  // MapSelect expects [lon, lat]
  setPosition([lon, lat]);
} else {
  setPosition(null);
}
    } catch (err) {
      console.error("Failed to prefill intervention:", err);
      setErrorSB(true);
    } finally {
      setLoadingPrefill(false);
    }
  };

  fetchIntervention();
}, [id]);



  function bringSuccessNotification() {
    return (
      <MDSnackbar
        color="success"
        icon="check"
        title="Ατυχήματα Ειδοποίηση"
        content="Επιτυχής εγγραφή παρέμβασης"
        dateTime={new Date().toLocaleTimeString()}
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
    );
  }

  function bringErrorNotification() {
    return (
      <MDSnackbar
        color="error"
        icon="warning"
        title="Ατυχήματα Ειδοποίηση"
        content="Αποτυχία εγγραφής παρέμβασης"
        dateTime={new Date().toLocaleTimeString()}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    );
  }
  // Build dropdown options from cluster JSON: label "name-id", value id
  const clusterOptions = (clustersData || []).map((c) => ({
    id: c.id,
    name: `cluster-${c.id}`,
  }));

  const fields = {
    programmed: [{ id: 1, name: "Προγραμματισμένο" }, { id: 2, name: "Μη προγραμματισμένο" }],
    category: [{ id: 1, name: "Κλειστός δρόμος" }, { id: 2, name: "Κλειστή λωρίδα" }, { id: 3, name: "Οδικές εργασίες" }, { id: 4, name: "Οδικά έργα" }, { id: 5, name: "Φραγμός δρόμου" }, { id: 6, name: "Πλημμυρισμένος δρόμος" }, { id: 7, name: "Ατύχημα δρόμου" }, { id: 8, name: "Συμβάν δρόμου" }],
    type_of_code: [{ id: 1, name: "Εκτεταμένης κλίμακας" }, { id: 2, name: "Διαγράμμιση οδοστρώματος" }, { id: 3, name: "Αργά κινούμενες εργασίες συντήρησης" }, { id: 4, name: "Γρήγορες εργασίες συντήρησης" }, { id: 5, name: "Βραχυπρόθεσμες εργασίες σταθερού πεδίου" }, { id: 6, name: "Εργασίες καθαρισμού οδού" }, { id: 7, name: "Εργασίες χειμερινής συντήρησης" }],
    cluster: [{ id: 1, name: "Cluster 1" }, { id: 1, name: "Cluster 2" }],
    status: [
      { id: 1, name: "Πρόταση" },
      { id: 2, name: "Μελέτη" },
      { id: 3, name: "On going" },
      { id: 4, name: "Κλειστό" }
    ],
    islands:[
  { "id": 1, "name": "Ρόδος" },
  { "id": 2, "name": "Κως" },
  { "id": 3, "name": "Κάλυμνος" },
  { "id": 4, "name": "Λέρος" },
  { "id": 5, "name": "Κάρπαθος" },
  { "id": 6, "name": "Κάσος" },
  { "id": 7, "name": "Πάτμος" },
  { "id": 8, "name": "Αστυπάλαια" },
  { "id": 9, "name": "Νίσυρος" },
  { "id": 10, "name": "Τήλος" },
  { "id": 11, "name": "Σύμη" },
  { "id": 12, "name": "Χάλκη" },
  { "id": 13, "name": "Λειψοί" },
  { "id": 14, "name": "Μεγίστη" },
  { "id": 15, "name": "Αγαθονήσι" },
  { "id": 16, "name": "Σύρος" }
]

  }

  const categorySub = [
    {
      id: 1,
      name: "Συντήρηση",
      subcategories: [
        { id: 1, name: "Εργασίες συντήρησης κατακόρυφης/οριζόντιας σήμανσης" },
        { id: 2, name: "Κλάδεμα φυτεύσεων" },
        { id: 3, name: "Διατάξεις ανάσχεσης ταχύτητας (ανακλαστήρες, ακουστικές λωρίδες)" },
        { id: 4, name: "Τοποθέτηση πεζοφάναρου/Αναλάμπων κίτρινος φανός πεζών" },
        { id: 5, name: "Ηλεκτρονικός εξοπλισμός Διαβάσεων" },
        { id: 6, name: "Αποκατάσταση φθορών οδοστρώματος" },
        { id: 7, name: "Άλλες παρεμβάσεις συντήρησης" }
      ]
    },
    {
      id: 2,
      name: "Έργο",
      subcategories: [
        { id: 8, name: "Κυκλικός Κόμβος" },
        { id: 9, name: "Νησίδα" },
        { id: 10, name: "Διάβαση πεζών" },
        { id: 11, name: "Υπέργεια διάβασης" },
        { id: 12, name: "Διαπλάτυνση δρόμου" },
        { id: 13, name: "Κατασκευή εσοχής" },
        { id: 20, name: "Άλλες υποδομές" },
        { id: 21, name: "Φωτεινή σηματοδότηση" },
        { id: 22, name: "Κυκλοφοριακές ρυθμίσεις" },
        { id: 23, name: "Άλλη κατασκευή" },
      ]
    },
    {
      id: 3,
      name: "Τεχνολογική παρέμβαση",
      subcategories: [
        { id: 14, name: "Κάμερες αστυνόμευσης" },
        { id: 15, name: "Κάμερες παρακολούθησης κυκλοφορίας" },
        { id: 16, name: "Αισθητήρες κυκλοφορίας" },
        { id: 17, name: "Έξυπνη σηματοδότηση" },
        { id: 18, name: "Πινακίδες μεταβλητών μηνυμάτων" },
        { id: 19, name: "Ηλεκτρονικές πινακίδες your speed is" },
         { id: 24, name: "Εφαρμογή C-ITS" },
        { id: 25, name: "Άλλη τεχνολογία" }

      ]
    }
  ];



  const handleInputChange = (field, value) => {
    if (field === "category") {
      setCategory(value.id);
      setSubCategory(''); // Reset υποκατηγορία όταν αλλάζει κατηγορία
      setSelectedCategory(value); // Set the selected category
    } else if (field === "subCategory") {
      setSubCategory(value?.id || '');
    } else if (field === "status") {
      setStatus(value?.id || '');
    } else if (field === "description") {
      setDescription(value || '');
    } else if (field === "cluster") {
      setCluster(value?.id ?? '');
    } else if (field === "island") {
  setIsland(value?.id || '');
    } 
    else {
      console.error("Unknown field: ", field);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    setFileName(file.name);
  };

const handleImportClick = () => {
  if (pdfInputRef.current) pdfInputRef.current.click();
};

const handlePdfChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  if (file.type !== "application/pdf") {
    setErrorSB(true);
    return;
  }

  setPdfFile(file);

  // allow selecting same file again later
  e.target.value = "";
};

const clearSelectedPdf = () => {
  setPdfFile(null);
};

const handleDeleteServerFile = async () => {
  if (!id || !existingFile?.id) return;

  setDeletingFile(true);
  try {
    const FILE_DELETE_URL = `${API_URL}/interventions/${id}/file`;
    await axios.delete(FILE_DELETE_URL, {
      headers: {
        "X-API-Key": API_TOKEN,
        accept: "*/*",
      },
    });

    setExistingFile(null);
    setPdfFile(null);
    setSuccessSB(true);
  } catch (err) {
    console.error(err);
    setErrorSB(true);
  } finally {
    setDeletingFile(false);
  }
};

const uploadPdfIfNeeded = async () => {
  if (!pdfFile) return;

  setUploadingFile(true);
  try {
    const FILE_UPLOAD_URL = `${API_URL}/interventions/${id}/file`;
    const fd = new FormData();
    fd.append("file", pdfFile);

    const res = await axios.post(FILE_UPLOAD_URL, fd, {
      headers: {
        "X-API-Key": API_TOKEN,
        accept: "*/*",
        "Content-Type": "multipart/form-data",
      },
    });

    // If backend returns updated file object, store it
    setExistingFile(res?.data?.file ?? res?.data ?? existingFile);
    setPdfFile(null);
  } finally {
    setUploadingFile(false);
  }
};


  const handleSubmit = async () => {
    // Απλό validation – προαιρετικό
    if (!category || !subCategory || !position || !cluster || !status) {
      console.warn("Missing required fields:", {
        category,
        subCategory,
        position,
        cluster,
        status,
      });
      return;
    }

    // position = [lat, lng] αλλά το API θέλει [lng, lat]
    //const [lat, lng] = position;

    const payload = {
      // εδώ στέλνεις τα ids όπως τα έχεις στο state
      islandId: island,         // από το dropdown
      categoryId: category,         // π.χ. "maintenance"
      subcategoryId: subCategory,
      statusId: status,             // π.χ. "sub1"
      nameEl: "Παρέμβαση", // δεν έχεις πεδίο τίτλου, οπότε reuse την περιγραφή ή βάλε default
      scheduleId: 1,                // TODO: αν αργότερα έχεις schedule, βάλε το πραγματικό id
      clusterId: Number(cluster),   // από το dropdown (id από clustersData)
      description: description || "",
      geometry: {
         type: "Point",
        coordinates: [position.reverse()]
      }, // [lng, lat]
    };

    try {
      console.log("Submitting intervention payload:", payload);
      console.log("Submitting intervention payload:", JSON.stringify(payload));
      const url = `${API_URL}/interventions/${id}`;

      await axios.put(url, payload, {
        headers: {
          'X-API-Key': API_TOKEN,
          'Content-Type': 'application/json'
        }
      });
      await uploadPdfIfNeeded();
      setSuccessSB(true);
      setTimeout(() => {
        navigate("/list/interventions"); // adjust if your route differs
      }, 3000);
    } catch (error) {
      console.log(error);
      setErrorSB(true);
    }
  };

  return (
    <DashboardLayout>
      <Grid container spacing={3} sx={{ minHeight: '500px' }}>
        <Grid item xs={12} md={5}>
          <Card id="accident-form" sx={{ overflow: "visible" }}>
            <MDBox p={3}>
              <MDTypography variant="h5">Προβολή Παρεμβάσής #{id}</MDTypography>
            </MDBox>
            <MDBox component="form" pb={3} px={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MDTypography variant="button">Νησί</MDTypography>
                   
                  <Autocomplete
                    readOnly={!isEditing}
                    value={fields.islands.find((i) => i.id === island) || null}
                    options={fields.islands}
                    getOptionLabel={(o) => o.name}
                    onChange={(e, v) => handleInputChange("island", v)}
                    renderInput={(p) => <MDInput {...p} variant="standard" inputProps={{ ...p.inputProps, readOnly: !isEditing }} />}
                  />
                </Grid>
                {/* Category */}
                <Grid item xs={12}>
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Κατηγορία
                  </MDTypography>
                  <Autocomplete
                    readOnly={!isEditing}
                    value={categorySub.find((type) => type.id === category) || null}
                    options={categorySub}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, selectedOption) => handleInputChange("category", selectedOption)}
                    renderInput={(params) => (<MDInput {...params} variant="standard" inputProps={{ ...params.inputProps, readOnly: !isEditing }} />)}
                  />
                </Grid>

                {/* Subcategory */}
                {selectedCategory && (
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Υποκατηγορία
                    </MDTypography>
                    <Autocomplete
                      readOnly={!isEditing}
                      value={selectedCategory.subcategories.find((sub) => sub.id === subCategory) || null}
                      options={selectedCategory.subcategories}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) => handleInputChange("subCategory", selectedOption)}
                      renderInput={(params) => <MDInput {...params} variant="standard" inputProps={{ ...params.inputProps, readOnly: !isEditing }} />}
                    />
                  </Grid>
                )}
                {/* Status */}
                
                <Grid item xs={12}>
                <MDTypography
                  component="label"
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  Κατάσταση παρέμβασης
                </MDTypography>

                <Autocomplete
                  readOnly={!isEditing}
                  value={fields.status.find((s) => s.id === status) || null}
                  options={fields.status}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, selectedOption) =>
                    handleInputChange("status", selectedOption)
                  }
                  renderInput={(params) => (
                    <MDInput {...params} variant="standard" inputProps={{ ...params.inputProps, readOnly: !isEditing }} />
                  )}
                />
                </Grid>
            
                {/* Position */}
                <Grid item xs={12} sm={12} container direction="column">
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Θέση Παρέμβασης
                  </MDTypography>
                  {!position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Επέλεξε Θέση στο Χάρτη
                    </MDTypography>
                  )}
                  {position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Lat: {position[0]}
                    </MDTypography>
                  )}
                  {position && (
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Long: {position[1]}
                    </MDTypography>
                  )}
                </Grid>


                {/* NEW: Cluster dropdown (from JSON, label=name-id, value=id) */}
                <Grid item xs={12}>
                  <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Cluster
                  </MDTypography>
                  <Autocomplete
                    readOnly={!isEditing}
                    value={
                      clusterOptions.find((o) => String(o.id) === String(cluster)) || null
                    }
                    options={clusterOptions}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, selectedOption) => handleInputChange("cluster", selectedOption)}
                    renderInput={(params) => (<MDInput {...params} variant="standard" inputProps={{ ...params.inputProps, readOnly: !isEditing }} />)}
                  />
                </Grid>

                {/* Description at the end (optional) */}
                <Grid item xs={12} sm={12}>
                  <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Σύντομη Περιγραφή/Παρατηρήσεις
                    </MDTypography>
                  </MDBox>
                    <MDInput
                    multiline
                    fullWidth
                    value={description || ""}
                    onChange={(e) => handleInputChange("description", e)}
                    inputProps={{ readOnly: !isEditing }}
                    />
                </Grid>
                {/* PDF Upload / Replace / Delete */}
<Grid item xs={12}>
  <MDTypography component="label" variant="button" fontWeight="regular" color="text" sx={{ mb: 1 }}>
    Συνημμένο PDF
  </MDTypography>

  <input
    type="file"
    accept="application/pdf"
    ref={pdfInputRef}
    onChange={handlePdfChange}
    style={{ display: "none" }}
  />

  <MDBox display="flex" flexWrap="wrap" gap={1} alignItems="center">
    {/* Case 1: server has file and user hasn't selected a new one */}
    {existingFile && !pdfFile && (
      <>
        <MDTypography variant="button" color="text">
          {existingFile.fileName} • {formatBytes(existingFile.fileSizeBytes)}
        </MDTypography>

        <MDButton
      
          variant="contained"
          color="warning"
          onClick={handleImportClick}
          disabled={uploadingFile || deletingFile}
          sx={{ "&.MuiButton-root": { textTransform: "none" } }}
        >
          Αντικατάσταση PDF
        </MDButton>

        <MDButton
          variant="contained"
          color="error"
          onClick={handleDeleteServerFile}
          disabled={uploadingFile || deletingFile}
          sx={{ "&.MuiButton-root": { textTransform: "none" } }}
        >
          {deletingFile ? "Διαγραφή..." : "Διαγραφή PDF"}
        </MDButton>
      </>
    )}

    {/* Case 2: user picked a new pdf (pending upload on Update) */}
    {pdfFile && (
      <>
        <MDTypography variant="button" color="text">
          Επιλεγμένο: {pdfFile.name} • {formatBytes(pdfFile.size)}
        </MDTypography>

        <MDButton
          variant="outlined"
          color="info"
          onClick={clearSelectedPdf}
          disabled={uploadingFile || deletingFile}
          sx={{ "&.MuiButton-root": { textTransform: "none" } }}
        >
          Ακύρωση αλλαγής
        </MDButton>

        <MDTypography variant="caption" color="text" sx={{ opacity: 0.8 }}>
          Το PDF θα ανέβει όταν πατήσετε «Ενημέρωση».
        </MDTypography>
      </>
    )}

    {/* Case 3: no server file and no selected file */}
    {!existingFile && !pdfFile && (
      <MDButton
        variant="contained"
        color="warning"
        onClick={handleImportClick}
        disabled={uploadingFile || deletingFile}
        sx={{ "&.MuiButton-root": { textTransform: "none" } }}
      >
        Ανέβασμα PDF
      </MDButton>
    )}
  </MDBox>
</Grid>
                {/* Submit */}
                <Grid mt={3} item xs={12} sm={12}>
                <MDBox
                  display="flex"
                  justifyContent="flex-end"   // 👈 this does the right alignment
                  alignItems="center"
                >
                <MDButton
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/list/interventions")}
                sx={{ "&.MuiButton-outlined": { textTransform: "capitalize !important" } }}
                >
                Ακύρωση
                </MDButton>
                </MDBox>

                </Grid>


              </Grid>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <div className='mapContainer100'>
            <MapSelect
              selectedPoint={position}
              setSelectedPoint={setPosition}
              clusterName={cluster}          // passes selected id
              setClusterName={setCluster}     // keep compatibility with MapSelect
            />
          </div>
        </Grid>
        {successSB && bringSuccessNotification()}
        {errorSB && bringErrorNotification()}
      </Grid>
    </DashboardLayout>
  );
};

export default InterventionFormReadOnly;
